import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import firebase from 'firebase/compat/app';
import { FormGroup, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { Observable, Subject, Subscription } from 'rxjs';
import {
  ClientType,
  EditingStatus,
  LIST_DATE_TIME_FORMAT,
  clientServiceTypePDropdownItems,
  subscriptionLengthTypePDropdownItems,
  subscriptionTypePDropdownItems,
  usStates,
} from 'app/core/models/common-types';
import REGEX_TYPES, {
  formatPhoneNumber,
  removeAllSpaces,
  validatePhoneInput,
  validatePhoneNumber,
} from 'app/shared/utils/rc-types/regex-types';
import { AuthStateService } from 'app/auth/store/auth.state-service';
import { ConfirmationService } from 'primeng/api';
import { ClientStateService } from 'app/features/admin/clients/store/client.state-service';
import { CommonModule } from '@angular/common';
import { PrimeNgModule } from '@core/primeng.module';
import {
  Client,
  defaultClient,
  ClientListItem,
  toClientListItem,
  toClientPayload,
} from 'app/features/admin/clients/model/Client';
import { NotificationService, ROUTE_ANIMATIONS_ELEMENTS } from '@core/core.module';
import { FileUpload } from '@core/models/FileUpload';
import { FileUploadService } from '@core/services/file-upload/file-upload.service';
import { getDatePayloadFromDate } from '@shared/utils/timestamp-utils';
import { ClientSubscription, toClientSubscriptionItem } from 'app/features/admin/clients/model/ClientSubscription';

@Component({
  selector: 'app-edit-client',
  standalone: true,
  imports: [CommonModule, PrimeNgModule, ReactiveFormsModule],
  templateUrl: './edit-client.component.html',
  styleUrls: ['./edit-client.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditClientComponent implements OnInit, OnDestroy {
  componentDestroyed$: Subject<null> = new Subject();
  selectedFile: File;
  currentFileUpload: FileUpload;
  imagePreview: string | ArrayBuffer;
  editClientForm: FormGroup;
  stateOptions = usStates;

  selectedState: string | undefined;
  filteredOptions: Observable<string[]>;
  selectedClient: ClientListItem;
  clientListItems: ClientListItem[] = [];
  clientEditingStatus = EditingStatus.NOT_EDITING;
  isSuperUser = false;
  percentage = 0;
  uploadProgress$: Observable<number>;
  submitted = false;
  pageTitle = 'Edit Client Info';
  clientServiceTypePDropdownItems = clientServiceTypePDropdownItems;
  subscriptionTypePDropdownItems = subscriptionTypePDropdownItems;
  subscriptionLengthTypePDropdownItems = subscriptionLengthTypePDropdownItems;
  isLoading = true;

  minDate: Date;
  maxDate: Date;

  private subscriptions = new Subscription();
  constructor(
    private clientStateService: ClientStateService,
    private authStateService: AuthStateService,
    private confirmationService: ConfirmationService,
    private formBuilder: FormBuilder,
    private changeDetector: ChangeDetectorRef,
    private fileUploadService: FileUploadService,
    private notificationsService: NotificationService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.updateTheForm(toClientListItem(defaultClient));
    this.subscriptions.add(
      this.route.params.subscribe((params) => {
        console.log('MS EditClientComponent params = ', params);
        if (params['editingStatus'] === 'EDITING') {
          this.pageTitle = 'Edit Client Info';
        } else {
          this.pageTitle = 'Enter New Client Info';
        }
      })
    );

    this.subscriptions.add(
      this.authStateService.isSuperUser$.subscribe((isSuperUser) => {
        this.isSuperUser = isSuperUser;
      })
    );
    this.subscriptions.add(
      this.clientStateService.clientEditingStatus$.subscribe((clientEditingStatus) => {
        this.clientEditingStatus = clientEditingStatus;
        console.log('MS EditClientComponent clientEditingStatus = ', clientEditingStatus);
      })
    );
    this.subscriptions.add(
      this.clientStateService.selectedClient$.subscribe((selectedClient) => {
        if (selectedClient) {
          // } && this.clientEditingStatus === EditingStatus.EDITING) {
          this.selectedClient = selectedClient;
          this.updateTheForm(this.selectedClient);
        }
      })
    );

    // this.filteredOptions = this.editClientForm
    //   .get('stateGroup')
    //   .valueChanges.pipe(
    //     startWith(''),
    //     map((value) => this._filter(value))
    //   );
    //   this.subscriptions.add(
    //     this.editClientForm
    //       .get('imageFile')
    //       .valueChanges.pipe()
    //       .subscribe((newValue) => {
    //         this.handleFileChange(newValue.files);
    //       })
    //   );

    this.subscriptions.add(
      this.clientStateService.clientListItems$.subscribe((clientListItems) => {
        this.clientListItems = clientListItems;
      })
    );
  }

  // handleFileChange([productImage]) {
  //   this.selectedFile = productImage;
  //   //  console.log('MS valid = ', this.editClientForm.valid);

  //   if (this.selectedFile.size <= IMAGE_UPLOAD_MAX_SIZE) {
  //     this.submitted = true;
  //     this.editClientForm.patchValue({ imagePath: this.selectedFile.name });
  //     const reader = new FileReader();
  //     //  reader.onload = (loadEvent) => (this.imagePreview = loadEvent.target.result);
  //     reader.onload = (loadEvent) => {
  //       this.imagePreview = loadEvent.target.result
  //       const img = new Image();
  //       img.src = reader.result as string;
  //        img.onload = () => {
  //           const height = img.naturalHeight;
  //           const width = img.naturalWidth;
  //           // console.log('MS Width and Height', width, height);
  //       };

  //       //   console.log('MS imagePreview = ', this.imagePreview);
  //       if (this.selectedFile) {
  //         this.currentFileUpload = new FileUpload(this.selectedFile);

  //         const { downloadUrl$, uploadProgress$ } = this.fileUploadService.uploadFileAndGetMetadata(
  //           this.editClientForm.value.path, this.currentFileUpload
  //         );
  //         this.uploadProgress$ = uploadProgress$;
  //         downloadUrl$
  //           .pipe(
  //             takeUntil(this.componentDestroyed$),
  //             catchError((error) => {
  //               this.notificationsService.error(error.message);
  //               return EMPTY;
  //             }),
  //           )
  //           .subscribe((downloadUrl) => {
  //             this.submitted = false;
  //             //    console.log('MS downloadUrl = ', downloadUrl);
  //             this.editClientForm.patchValue({ imageUrl: downloadUrl });
  //           });
  //       }
  //       this.changeDetector.detectChanges();
  //     };
  //     reader.readAsDataURL(productImage);
  //   }
  // }
  // hexToRgb(hex) {
  //   const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  //   hex = hex.replace(shorthandRegex, (m, r, g, b) => r + r + g + g + b + b);
  //   const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  //   return result ? {
  //     r: parseInt(result[1], 16),
  //     g: parseInt(result[2], 16),
  //     b: parseInt(result[3], 16)
  //   } : null;
  // }

  // private _filter(value: string): string[] {
  //   const filterValue = value.toLowerCase();
  //   return this.options.filter(option => option.toLowerCase().includes(filterValue));
  // }

  updateTheForm(clientListItem: ClientListItem) {
    console.log('MS updateTheForm clientListItem= ', clientListItem);
    // console.log('MS updateTheForm client = ', client);
    const newClient: ClientListItem = { ...clientListItem };
    // if (this.clientEditingStatus !== EditingStatus.NOT_EDITING) {
    //   newClient = { ...this.selectedClient };
    // }
    console.log('MS updateTheForm newClient= ', newClient);
    const serviceTypeItem = clientServiceTypePDropdownItems.find((item) => item.value === newClient.serviceType);
    console.log('MS updateTheForm serviceTypeItem = ', serviceTypeItem);

    const stateItem = usStates.find((item) => item.code === newClient.state);
    console.log('MS updateTheForm stateItem = ', stateItem);

    const subscriptionTypeItem = this.subscriptionTypePDropdownItems.find(
      (item) => item.value === newClient.clientSubscription?.subscriptionType
    );

    const subscriptionLengthTypeItem = this.subscriptionLengthTypePDropdownItems.find(
      (item) => item.value === newClient.clientSubscription?.subscriptionLengthType
    );
    console.log('MS updateTheForm serviceTypeItem = ', serviceTypeItem);

    this.editClientForm = this.formBuilder.group({
      address: newClient.address,
      city: [newClient.city, Validators.required],
      //  clientType: [newClient.clientType, Validators.required],
      contactName: [newClient.contactName, Validators.required],
      email: [newClient.email, [Validators.required, Validators.pattern(REGEX_TYPES.EMAIL)]],
      imageFile: undefined,
      isActive: newClient.isActive,
      // import { FileValidator } from 'ngx-material-file-input';
      //  TODO need validator replacement imageFile: [undefined, FileValidator.maxContentSize(IMAGE_UPLOAD_MAX_SIZE)],
      imagePath: [newClient?.imagePath],
      imageUrl: [newClient?.imageUrl],
      name: [newClient.name, Validators.required],
      path: [newClient.path, Validators.required],
      phone: [newClient.phone, [Validators.required, validatePhoneInput]],
      reportHeaderColor: newClient.reportHeaderColor, //  [new Color(rgb.r,rgb.g,rgb.b,1), Validators.compose([Validators.required])],
      // TODO need validator replacement  import { Color } from '@angular-material-components/color-picker';
      serviceTypeItem: [serviceTypeItem, Validators.required],
      subscriptionTypeItem,
      subscriptionLengthTypeItem,

      subscriptionStartDate: [newClient.clientSubscriptionItem.startDatePayload?.date, Validators.required],

      subscriptionEndDate: [newClient.clientSubscriptionItem.endDatePayload?.date, Validators.required],
      // serviceType: [newClient.serviceType, Validators.required],
      // state: newClient.state,
      stateItem: [stateItem, Validators.required],
      zip: [newClient.zip, Validators.required],
    });

    if (this.editClientForm.value.imageUrl && this.editClientForm.value.imagePath) {
      this.imagePreview = this.editClientForm.value.imageUrl;
      this.changeDetector.detectChanges();
    }
  }
  updateDisplayName() {
    const path = removeAllSpaces(this.editClientForm.value.name, true);
    this.editClientForm.patchValue({ path });
  }

  getClientFromForm(): Client {
    console.log('MS getEditedClient editClientForm.value= ', this.editClientForm.value);
    const newClientSubscription: ClientSubscription = {
      subscriptionType: this.editClientForm.value.subscriptionTypeItem.value,
      subscriptionLengthType: this.editClientForm.value.subscriptionLengthTypeItem.value,
      startTimestamp: firebase.firestore.Timestamp.fromDate(this.editClientForm.value.subscriptionStartDate),
      endTimestamp: firebase.firestore.Timestamp.fromDate(this.editClientForm.value.subscriptionEndDate),
      monthlyPrice: 99,
      yearlyPrice: 999,
      discount: 0,
    };
    const retVal: Client = {
      address: this.editClientForm.value.address,
      // businessModelType: this.selectedClient.businessModelType ??ClientBusinessModelType.CONTRACTOR,
      clientSubscription: newClientSubscription,
      city: this.editClientForm.value.city,
      clientType: ClientType.PROJASTIC_CLIENT,
      contactName: this.editClientForm.value.contactName,
      email: this.editClientForm.value.email,
      imagePath: this.editClientForm.value.imagePath ? this.editClientForm.value.imagePath : null,
      isActive: this.editClientForm.value.isActive,
      // sgImageType: this.editClientForm.value.sgImageType,
      imageUrl: this.editClientForm.value.imageUrl ?? null,
      name: this.editClientForm.value.name,
      path: this.editClientForm.value.path,
      phone: this.editClientForm.value.phone,
      reportHeaderColor: this.editClientForm.value.reportHeaderColor,
      serviceType: this.editClientForm.value.serviceTypeItem.value,
      state: this.editClientForm.value.stateItem.code,
      slogan: 'No Slogan yet',
      zip: this.editClientForm.value.zip,
    };
    console.log('MS getEditedClient END retVal= ', retVal);
    return retVal;
  }

  onSaveClient() {
    // console.log('MS editClientForm = ', this.editClientForm.value);
    if (!this.editClientForm.valid) {
      return;
    }
    if (validatePhoneNumber(this.editClientForm.value.phone)) {
      this.editClientForm.patchValue({
        phone: formatPhoneNumber(this.editClientForm.value.phone),
      });
    }
    console.log('MS onSaveClient editClientForm = ', this.editClientForm.value);
    const newClient = this.getClientFromForm();

    console.log('MS onSaveClient 2 newClient= ', newClient);
    if (this.clientEditingStatus !== EditingStatus.EDITING) {
      console.log('MS onSaveClient this.clientListItems = ', this.clientListItems);
      const duplicate = this.clientListItems.find((cl) => cl.email === newClient.email);

      console.log('MS onSaveClient duplicate = ', duplicate);
      if (duplicate && this.clientEditingStatus === EditingStatus.NOT_EDITING) {
        this.confirmationService.confirm({
          header: 'Add Client Error',
          message: 'The Client entered already exists!',
          icon: 'pi pi-exclamation-triangle',
          acceptLabel: 'OK',
          accept: () => {
            // this.messageService.add({ severity: 'info', summary: 'OK', detail: 'You have accepted' });
          },
        });
      } else {
        console.log('MS onSaveClient ADDING newClient= ', newClient);
        this.clientStateService.addClient(newClient);
      }
    } else {
      // we are editing
      console.log('MS onSaveClient EDITING newClient= ', newClient);
      const updateClientListItem = {
        ...this.selectedClient,
        ...newClient
      };
      this.clientStateService.updateClient(updateClientListItem);
    }
    this.clientStateService.setClientEditingStatus(EditingStatus.NOT_EDITING);
    this.router.navigate(['/admin/clients-list']);
  }

  onCancelClient() {
    this.clientStateService.setClientEditingStatus(EditingStatus.NOT_EDITING);
    this.router.navigate(['/admin/clients-list']);
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
